<template>
	<teleport :to="'head'">
		<title>
			{{ content }}
		</title>
	</teleport>
</template>

<script setup>
	import { useSlots } from 'vue'

	let content = useSlots().default()[0].children
</script>
